import React from "react";
import axios from "axios";
import { Modal } from "antd";
import { fetchOfferListRoute } from "../../../lib/routes/offering";
import { catchApiError } from "../../../lib/utils/catchApiError";
import { IChangingMode, ICreateMode } from "../../../lib/types";

type Props<T> = {
  viewMode?: IChangingMode | ICreateMode;
  name?: string;
  offerVersions?: T[];
};

// Проверка кода предложения (name) на уникальность
export const validateOfferNameUniqueness = async <T extends { name?: string; id?: number }>(
  props: Props<T>
): Promise<boolean> => {
  const { name, viewMode, offerVersions = [] } = props;
  if (!name) {
    return false;
  }
  const trimmedName = name.trim();
  // При редактировании: валидация не проводится, если имя совпадает с именем какой-либо версии
  if (viewMode === "edit" || viewMode === "add") {
    const isSameName = offerVersions.some(({ name }) => name?.trim() === trimmedName);
    if (isSameName) {
      return true;
    }
  }
  try {
    const response = axios.get(
      fetchOfferListRoute({
        name: trimmedName,
      })
    );
    const { data } = await response;
    const isUnique = !data.content?.length ? true : data.content[0].id === offerVersions?.[0]?.id;
    if (!isUnique) {
      const offerId = data.content[0].id;
      Modal.error({
        title: "Ошибка",
        content: (
          <>
            Код <strong>{name}</strong> уже существует у предложения id = <strong>{offerId}</strong>
          </>
        ),
      });
    }
    return isUnique;
  } catch (e) {
    return catchApiError({
      e,
      title: "Ошибка проверки кода предложения. Попробуйте позже",
    });
  }
};
